/**
 * @public
 */
export interface SerializedError {
  name?: string;
  message?: string;
  stack?: string;
  code?: string;
  details?: string;
  parameter?: string;
  requestId?: string;
  siteAttr?: number;
  error?: string;
  retryInSec?: number;
  neoOffering?: string;
}

const commonProperties: Array<keyof SerializedError> = [
  'name',
  'message',
  'stack',
  'code',
  'details',
  'parameter',
  'requestId',
  'siteAttr',
  'error',
  'retryInSec',
  'neoOffering',
];

/**
 * To Serializes an error into a plain object.
 * Reworked from https://github.com/sindresorhus/serialize-error
 *
 * @public
 */
export const miniSerializeErrorOverride = (value: any): SerializedError => {
  if (typeof value === 'object' && value !== null) {
    const simpleError: SerializedError = {};
    for (const property of commonProperties) {
      if (['string', 'number', 'boolean'].includes(typeof value[property])) {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }

  return { message: String(value) };
};
